import { getCurrentInstance } from '@vue/composition-api'
import store from '@store'

/**
 * Returns ability result if ACL is configured or else just return true
 * Useful if you don't know if ACL is configured or not
 * Used in @core files to handle absence of ACL without errors
 * @param permission
 * @param isHidden
 */
export const can = (permission, isHidden = false) => {
  if (isHidden) return false
  const userData = store.state.user.data

  if (!userData) return false
  if (userData.roles.includes('Administrator')) return true
  if (!permission) return true
  if (userData.permissions.includes(permission)) return true
  return false
}

/**
 * Check if user can view item based on it's ability
 * Based on item's action and resource
 * @param {Object} item navigation object item
 */
export const canViewVerticalNavMenuLink = item => can(item.permission, item.hidden)

/**
 * Check if user can view item based on it's ability
 * Based on item's action and resource & Hide group if all of it's children are hidden
 * @param {Object} item navigation object item
 */
// eslint-disable-next-line arrow-body-style
// export const canViewVerticalNavMenuGroup = item => {
export const canViewVerticalNavMenuGroup = item => {
  const allItems = findPermissionObject([item])
  // ? Same logic as canViewVerticalNavMenuGroup
  const hasAnyVisibleChild = allItems.some(i => can(i.permission))

  // If resource and action is defined in item => Return based on children visibility (Hide group if no child is visible)
  // Else check for ability using provided resource and action along with checking if has any visible child
  if (!(item.permission)) {
    return hasAnyVisibleChild
  }
  return can(item.permission) && hasAnyVisibleChild
}

/**
 * Check if user can view item based on it's ability
 * Based on item's action and resource
 * @param {Object} item navigation object item
 */
export const canViewVerticalNavMenuHeader = item => {
  // console.log('fff',  findPermissionObject(item))
  return true
  // ? Same logic as canViewVerticalNavMenuGroup
  // const hasAnyVisibleChild = item.children?.some(i => can(i.permission))
  // // const hasAnyVisibleChild = true
  //
  // // If resource and action is defined in item => Return based on children visibility (Hide group if no child is visible)
  // // Else check for ability using provided resource and action along with checking if has any visible child
  // if (!(item.permission)) {
  //   return hasAnyVisibleChild
  // }
  // return can(item.permission) && hasAnyVisibleChild
}

/**
 * Check if user can view item based on it's ability
 * Based on item's action and resource
 * @param {Object} item navigation object item
 */
export const canViewHorizontalNavMenuLink = item => can(item.action, item.resource)

/**
 * Check if user can view item based on it's ability
 * Based on item's action and resource
 * @param {Object} item navigation object item
 */
export const canViewHorizontalNavMenuHeaderLink = item => can(item.action, item.resource)

/**
 * Check if user can view item based on it's ability
 * Based on item's action and resource & Hide group if all of it's children are hidden
 * @param {Object} item navigation object item
 */
// eslint-disable-next-line arrow-body-style
export const canViewHorizontalNavMenuGroup = item => {
  // ? Same logic as canViewVerticalNavMenuGroup
  const hasAnyVisibleChild = item.children.some(i => can(i.action, i.resource))

  // If resource and action is defined in item => Return based on children visibility (Hide group if no child is visible)
  // Else check for ability using provided resource and action along with checking if has any visible child
  if (!(item.action && item.resource)) {
    return hasAnyVisibleChild
  }
  return can(item.action, item.resource) && hasAnyVisibleChild
}

// eslint-disable-next-line arrow-body-style
export const canViewHorizontalNavMenuHeaderGroup = item => {
  // ? Same logic as canViewVerticalNavMenuGroup but with extra content

  // eslint-disable-next-line arrow-body-style
  const hasAnyVisibleChild = item.children.some(grpOrItem => {
    // If it have children => It's grp
    // Call ACL function based on grp/link
    return grpOrItem.children ? canViewHorizontalNavMenuGroup(grpOrItem) : canViewHorizontalNavMenuLink(grpOrItem)
  })

  // If resource and action is defined in item => Return based on children visibility (Hide group if no child is visible)
  // Else check for ability using provided resource and action along with checking if has any visible child
  if (!(item.action && item.resource)) {
    return hasAnyVisibleChild
  }
  return can(item.action, item.resource) && hasAnyVisibleChild
}

let findPermissionObject = (arr, res = []) => {
  for (let obj of arr) {
    if (typeof obj.permission !== 'undefined') {
      res.push(obj)
    }
    if (obj.children) {
      findPermissionObject(obj.children, res)
    }
  }
  return res
}
